export default __webpack_public_path__ + "static/media/h1.5d34eaca.png";